import { render, staticRenderFns } from "./HouseList.vue?vue&type=template&id=4951fc84"
import script from "./HouseList.vue?vue&type=script&lang=js"
export * from "./HouseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports